import { render } from "./z-timeline.vue?vue&type=template&id=2fab6ae3&scoped=true"
import script from "./z-timeline.vue?vue&type=script&lang=js"
export * from "./z-timeline.vue?vue&type=script&lang=js"

import "./z-timeline.vue?vue&type=style&index=0&id=2fab6ae3&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fab6ae3"]])

export default __exports__